import api from 'js/api'
export const verifyAccountEmail = (code) =>
  api('POST', `v2/accounts/verify_account/${code}/`)
